import { render, staticRenderFns } from "./intermediary.vue?vue&type=template&id=212f6337&scoped=true"
import script from "./intermediary.vue?vue&type=script&lang=js"
export * from "./intermediary.vue?vue&type=script&lang=js"
import style0 from "./intermediary.vue?vue&type=style&index=0&id=212f6337&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212f6337",
  null
  
)

export default component.exports